<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div
		*ngIf="isCommercial && !outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property type not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Policies for commerical properties must be ordered directly from Chicago
			Title. Please contact Chicago Title directly to submit your order.
		</p>
	</div>
	<div
		*ngIf="outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property location not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Policies for properties outside of Ontario are not supported. Please
			select a different property.
		</p>
	</div>
	<div
		*ngIf="orderValid && !isCommercial"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon [icon]="ICON.CHECK" class="text-green text-4xl"></app-icon>
		<p class="text-xl">Ready to begin order!</p>
		<p>
			You've collected everything you need to begin your order with Chicago
			Title
		</p>
	</div>
	<div
		*ngIf="!orderValid && !isCommercial && !outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl">Missing fields</p>
		<atomic-message-bar
			*ngIf="showPriorityWarning"
			type="warn"
			[shadow]="false"
			[testHook]="testHooks.MessageBar"
		>
			<p>
				A
				<span
					class="cursor-pointer underline"
					(click)="editPriority()"
					[testHook]="testHooks.EditPrioritySpan"
					>New Mortgage</span
				>
				and an
				<span
					class="cursor-pointer underline"
					(click)="editPriority()"
					[testHook]="testHooks.EditPrioritySpan1"
					>Encumbrance (Remain)</span
				>
				have the same priority selected.
			</p>
		</atomic-message-bar>
		<p class="mx-5 text-sm text-center">
			The following fields must be added to Closer to submit your order
		</p>
		<div class="flex flex-col flex-1 justify-center px-10 w-96">
			<div
				class="items-center text-center"
				*ngFor="let fieldSection of missing"
			>
				<p class="mb-1 mt-5 font-bold">{{ fieldSection.sectionName }}</p>
				<div
					*ngFor="let field of fieldSection.fields"
					class="flex mt-2 items-center justify-center text-center"
				>
					<app-icon [icon]="ICON.ERROR" class="text-red mr-3"></app-icon>
					<app-anchor
						*ngIf="field.fieldName !== 'Closing date'"
						(click)="field?.url || field?.openDrawer()"
						[url]="field?.url"
						[queryParams]="backUrlParams"
						type="static"
						[testHook]="testHooks.Link"
						>{{ field.fieldName }}</app-anchor
					>
					<button
						*ngIf="field.fieldName === 'Closing date'"
						type="button"
						(click)="openKeyDatesDrawer($event)"
						class="text-green-600 underline"
						[testHook]="testHooks.OpenKeyDatesDrawerButton"
					>
						{{ field.fieldName }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button
			*ngIf="orderValid"
			(click)="openPortal()"
			[icon]="ICON.RESEND"
			[disabled]="!orderValid"
			[testHook]="testHooks.StartOrderButton"
			>Start order</app-button
		>
		<app-button
			*ngIf="isCommercial"
			(click)="changePropertyType()"
			[icon]="ICON.EDIT"
			[testHook]="testHooks.ChangePropertyTypeButton"
			>Change property type</app-button
		>
		<app-button
			*ngIf="!isCommercial && outOfOntario"
			(click)="changePropertyType()"
			[icon]="ICON.EDIT"
			[testHook]="testHooks.ChangePropertyAddressButton"
			>Change property address</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-chicago-footer
			[status]="chicagoStatus.NOT_SUBMITTED"
		></app-chicago-footer>
	</div>
</div>
